// src/components/CrucesTable.js
import Papa from 'papaparse';
import React, { Fragment, useEffect, useState, useRef, useCallback, useMemo } from 'react';
import apiClient from '../../api/client';
import dayjs from 'dayjs';
import { useSearchParams } from "react-router-dom";
import { formatearFecha, ModalHandleEditarCruce } from '../shared/utils';
import EditRutaPanel from '../shared/EditRutaPanel';
import { FunnelX, Grid2X2Check } from 'lucide-react';


const meses = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];


const bases = ["Base Monterrey", "Base Cd. Sahagún", "Administrativos"];




const API_URL = process.env.REACT_APP_API_URL;

const ZONA_HORARIA_MEXICO = 'America/Mexico_City';

const formatearFechaHora = (fecha) => {
  if (!fecha) return '-';

  const fechaFormateada = new Date(fecha);
  if (Number.isNaN(fechaFormateada.getTime())) return '-';

  return fechaFormateada.toLocaleString('es-MX', {
    timeZone: ZONA_HORARIA_MEXICO,
    dateStyle: 'short',
    timeStyle: 'medium',
  });
};








function CrucesTable({ onDataFiltered }) {
  const checkboxes = useRef();
  const [searchParams, setSearchParams] = useSearchParams();
  const yearParam = searchParams.get("y");
  const monthParam = searchParams.get("m");
  const [selectedCruces, setSelectedCruces] = useState([]);
  const [progreso, setProgreso] = useState(null); // % de carga (0-100)
  const [sortColumn, setSortColumn] = useState(null); //Columna mandante para el ordenamiento
  const [sortDirection, setSortDirection] = useState('asc'); // Tipo de ordenamiento
  const [cruces, setCruces] = useState([]); // Cruces de la página actual (la paginación, filtros y orden los resuelve el servidor)
  const [total, setTotal] = useState(0); // Total de cruces que cumplen los filtros
  const [conteos, setConteos] = useState({ todos: 0, accion: 0, sinOT: 0, conOT: 0 }); // Totales por segmento (con los filtros comunes aplicados)
  const [segmento, setSegmento] = useState('accion'); // accion | conOT | sinOT | todos
  const [recarga, setRecarga] = useState(0); // Se incrementa para volver a consultar la página actual
  const [years, setYears] = useState([]); // Se almacenan los años disponibles
  const [selectedYear, setSelectedYear] = useState(null); // Se almacena el año seleccionado
  const [filtros, setFiltros] = useState({ fecha: '', mat_OP: '', tagID: '', Caseta: '', vOT: '', Estatus: '' }); //Se almacena el valor de los filtros. Pueden ser Fecha, no. economico y nombre de la caseta
  const [filtrosAplicados, setFiltrosAplicados] = useState(filtros); // Filtros ya con debounce, los que se envían al servidor
  const [rutasCache, setRutasCache] = useState({}); // Ruta por OT para la fila expandible: { [ot]: { loading, error, origen, destino, casetas } }
  const [cruceExpandido, setCruceExpandido] = useState(null); // ID del cruce con la ruta desplegada
  const [vCaseta, setvCaseta] = useState(''); //Para limpiar el valor del textbox de la Caseta
  const [vOT, setvOT] = useState(''); //Para limpiar el valor del textbox de la Caseta
  const [vFecha, setvFecha] = useState(''); //Para limpiar el valor del textbox de la fecha
  const [vtagID, setvtagID] = useState(''); //Para limpiar el valor del textbox de la fecha
  const [vEstatus, setvEstatus] = useState(''); //Para limpiar el valor del textbox del Estatus
  const [vmat_OP, setvmat_OP] = useState(''); //Para limpiar el valor del textbox del No.Economico
  const [loading, setLoading] = useState(true); // Consulta de cruces en curso
  const [mesSeleccionado, setMesSeleccionado] = useState(null);
  const [baseSeleccionada, setBaseSeleccionada] = useState(null);
  const [progressDetails, setProgressDetails] = useState({
    total: 0,
    processed: 0,
    inserted: 0,
    skipped: 0,
    remaining: 0,
    message: ''
  });
  const [eventSource, setEventSource] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [cruceSeleccionado, setCruceSeleccionado] = useState(null);
  const [importActiva, setImportActiva] = useState(false); // El proceso en curso es una importación de CSV (no una conciliación)
  const [cancelando, setCancelando] = useState(false); // Ya se solicitó la cancelación de la importación
  const parserRef = useRef(null); // Handle de PapaParse para abortar el parseo local
  const cancelRef = useRef(false); // Evita enviar el POST al backend si se canceló durante el parseo

  // Edit Ruta Panel (para CasetaNoEncontradaEnRuta)
  const [editRutaPanelData, setEditRutaPanelData] = useState(null); // { id_tipo_ruta, ot }
  const [editRutaPanelLoading, setEditRutaPanelLoading] = useState(false);

  const handleOpenEditRutaForCruce = async (cruce) => {
    if (!cruce.id_orden) { alert('Este cruce no tiene OT asignada'); return; }
    setEditRutaPanelLoading(true);
    try {
      const res = await apiClient.get(`/api/tracking/ot/${cruce.id_orden}`);
      const id_tipo_ruta = res.data?.info?.Id_tipo_ruta;
      if (!id_tipo_ruta) { alert('No se encontró la ruta para esta OT'); return; }
      const casetasRes = await apiClient.get(`/api/casetas/rutas/${id_tipo_ruta}/casetasPorRuta`);
      const initialCasetas = casetasRes.data || [];
      setEditRutaPanelData({ id_tipo_ruta, ot: cruce.id_orden, initialCasetas });
    } catch {
      alert('Error al obtener la información de la ruta');
    } finally {
      setEditRutaPanelLoading(false);
    }
  };

  const [paginaActual, setPaginaActual] = useState(1); //P2ágina actual, obviamente inicia en la primer página
  const [registrosPorPagina, setRegistrosPorPagina] = useState(250); //Filas por página.

  // Sincronizar estado local con los parámetros de la URL
  useEffect(() => {
    const m = searchParams.get("m");
    if (m !== null && m !== "") {
      setMesSeleccionado(parseInt(m) - 1);
    } else {
      setMesSeleccionado(null);
    }

    const y = searchParams.get("y");
    if (y !== null && y !== "") {
      setSelectedYear({ AÑO: parseInt(y) });
    } else {
      setSelectedYear(null);
    }
  }, [searchParams]);

  useEffect(() => {
    apiClient.get(`/api/cruces/years`)
      .then(res => {
        setYears(res.data);
      })
      .catch(err => console.error('Error al cargar años:', err));
  }, []);

  // Los filtros de texto se envían al servidor con debounce para no consultar en cada tecla
  useEffect(() => {
    const t = setTimeout(() => {
      setFiltrosAplicados(prev => (JSON.stringify(prev) === JSON.stringify(filtros) ? prev : filtros));
    }, 400);
    return () => clearTimeout(t);
  }, [filtros]);

  const filtrosAplicadosKey = JSON.stringify(filtrosAplicados);
  useEffect(() => {
    setPaginaActual(1);
  }, [filtrosAplicadosKey, mesSeleccionado, selectedYear, baseSeleccionada, segmento, registrosPorPagina, sortColumn, sortDirection]);

  const parametrosConsulta = useMemo(() => {
    const p = {
      page: paginaActual,
      pageSize: registrosPorPagina,
      segmento,
    };
    if (sortColumn) { p.sort = sortColumn; p.dir = sortDirection; }
    if (mesSeleccionado !== null) p.mes = mesSeleccionado + 1;
    if (selectedYear) p.anio = selectedYear.AÑO;
    if (baseSeleccionada) p.base = baseSeleccionada;
    if (filtrosAplicados.fecha) p.fecha = filtrosAplicados.fecha;
    if (filtrosAplicados.tagID) p.tag = filtrosAplicados.tagID;
    if (filtrosAplicados.vOT) p.ot = filtrosAplicados.vOT;
    if (filtrosAplicados.mat_OP) p.matOp = filtrosAplicados.mat_OP;
    if (filtrosAplicados.Caseta) p.caseta = filtrosAplicados.Caseta;
    if (filtrosAplicados.Estatus) p.estatus = filtrosAplicados.Estatus;
    return p;
  }, [paginaActual, registrosPorPagina, segmento, sortColumn, sortDirection, mesSeleccionado, selectedYear, baseSeleccionada, filtrosAplicados]);

  // Consulta de la página actual. Cancela la petición anterior si cambian los parámetros.
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    apiClient.get('/api/cruces/consulta', { params: parametrosConsulta, signal: controller.signal })
      .then(res => {
        setCruces(res.data.data);
        setTotal(res.data.total);
        setConteos(res.data.counts.segmentos);
        if (onDataFiltered) onDataFiltered(res.data.counts.estatus);
        setLoading(false);
      })
      .catch(err => {
        if (controller.signal.aborted) return;
        console.error('Error al cargar cruces:', err);
        setCruces([]);
        setTotal(0);
        setLoading(false);
      });
    return () => controller.abort();
    // onDataFiltered es un setState del padre (estable)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parametrosConsulta, recarga]);
  // Limpiar conexión SSE cuando el componente se desmonte
  useEffect(() => {
    return () => {
      if (eventSource) {
        eventSource.close();
      }
    };
  }, [eventSource]);

  const handleMostrarDialogoEdicionCruce = (cruce) => {
    setCruceSeleccionado(cruce);
    setShowModal(true);
  };

  const connectToProgressStream = async () => {
    // Obtener un ticket efímero de un solo uso desde el backend (llamada autenticada normal)
    const { data } = await apiClient.get('/api/cruces/sse-ticket');
    const { ticket } = data;

    const sseUrl = `${API_URL}/api/cruces/progress?ticket=${encodeURIComponent(ticket)}`;
    const es = new EventSource(sseUrl);

    es.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        switch (data.type) {
          case 'connected':
            break;
          case 'start':
            setProgreso(5);
            setProgressDetails({
              total: data.total,
              processed: 0,
              inserted: 0,
              skipped: 0,
              message: data.message
            });
            break;

          case 'progress':
            setProgreso(data.percentage);
            setProgressDetails({
              total: data.total,
              processed: data.processed,
              inserted: data.inserted,
              skipped: data.skipped,
              remaining: data.total - data.processed,
              message: data.message
            });
            break;

          case 'complete':
            setProgreso(100);
            setProgressDetails({
              total: data.total,
              processed: data.processed,
              inserted: data.inserted,
              skipped: data.skipped,
              message: data.message
            });

            // Cerrar la conexión SSE — el stream terminó
            es.close();

            // Mostrar resultado final
            setTimeout(() => {
              const esConciliacion = data.message?.toLowerCase().includes('conciliaci');
              if (esConciliacion) {
                alert(
                  `✅ Conciliación completada:\n` +
                  `📊 Total procesados: ${data.total} cruces\n` +
                  `✔️ Actualizados: ${data.actualizados || 0}\n` +
                  `❌ Omitidos: ${(data.omitidos?.incompletos || 0) + (data.omitidos?.fechaInvalida || 0)}`
                );
              } else {
                alert(
                  `✅ Importación completada:\n` +
                  `📊 Total procesados: ${data.total} registros\n` +
                  `✔️ Insertados: ${data.inserted}\n` +
                  `❌ Omitidos: ${data.skipped} (${data.omitidos?.incompletos || 0} incompletos, ` +
                  `${data.omitidos?.fechaInvalida || 0} con fecha inválida, ` +
                  `${data.omitidos?.duplicado || 0} duplicados)`
                );
              }

              // Recargar datos
              setRecarga(r => r + 1);
            }, 1000);

            // Limpiar después de 3 segundos
            setTimeout(() => {
              setProgreso(null);
              setProgressDetails({ total: 0, processed: 0, inserted: 0, skipped: 0, message: '' });
              setImportActiva(false);
              setCancelando(false);
              cancelRef.current = false;
            }, 3000);
            break;

          case 'cancelled':
            // El backend detuvo la importación a petición del usuario
            es.close();
            setProgreso(null);
            setProgressDetails({ total: 0, processed: 0, inserted: 0, skipped: 0, message: '' });
            setImportActiva(false);
            setCancelando(false);
            cancelRef.current = false;

            alert(
              `🛑 Importación cancelada:\n` +
              `📊 Procesados: ${data.processed?.toLocaleString()} de ${data.total?.toLocaleString()} registros\n` +
              `✔️ Insertados: ${data.inserted?.toLocaleString()}\n` +
              `❌ Omitidos: ${data.skipped?.toLocaleString()}\n\n` +
              `Los registros ya insertados se conservaron.`
            );

            // Recargar datos para reflejar los registros insertados antes de cancelar
            setRecarga(r => r + 1);
            break;

          case 'error':
            console.error('❌ Error en el stream:', data);
            alert(`❌ Error durante la importación: ${data.message}`);
            setProgreso(null);
            setImportActiva(false);
            setCancelando(false);
            cancelRef.current = false;
            break;

          default:
            console.warn('❓ Evento desconocido en SSE:', data);
            break;
        }
      } catch (error) {
        console.error('Error parsing SSE data:', error);
      }
    };

    es.onerror = (error) => {
      console.error('❌ Error en EventSource:', error);
      es.close();
    };

    setEventSource(es);
    return es;
  };


  const handleChange = e => {
    const { name, value } = e.target;
    if (selectedCruces.length !== 0) {
      setSelectedCruces([]);
    }
    switch (name) {
      case 'fecha':
        setSearchParams(prev => {
          const newParams = new URLSearchParams(prev);
          if (value) {
            newParams.set("m", dayjs(value).month() + 1);
            newParams.set("y", dayjs(value).year());
          } else {
            newParams.delete("m");
            newParams.delete("y");
          }
          return newParams;
        });
        setvFecha(e.target.value);
        break;
      case 'mat_OP':
        setvmat_OP(e.target.value);
        break;
      case 'tagID':
        setvtagID(e.target.value);
        break;
      case 'vOT':
        setvOT(e.target.value);
        break;
      case 'Caseta':
        setvCaseta(e.target.value);
        break;
      case 'Estatus':
        setvEstatus(e.target.value);
        break;
      default:
        break;
    }
    setFiltros(prev => ({ ...prev, [name]: value }));
  };
  const resetFiltros = () => {
    setFiltros(() => ({ fecha: '', mat_OP: '', vOT: '', tagID: '', Caseta: '', Estatus: '', mes: dayjs().month() }));
    setvCaseta('');
    setvEstatus('');
    setvmat_OP('');
    setvtagID('');
    setvOT('');
    setvFecha('');
  }
  const ordenarPor = (columna) => {
    if (sortColumn === columna) {
      setSortDirection(prev => (prev === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortColumn(columna);
      setSortDirection('asc');
    }
  };

  // Paginación calculada con el total que devuelve el servidor
  const totalPaginas = Math.ceil(total / registrosPorPagina);
  const indiceInicio = (paginaActual - 1) * registrosPorPagina;
  const paginaDatos = cruces;
  const idsVisibles = useMemo(() => cruces.map(c => c.ID), [cruces]);

  // ✅ Generar array de números de página para mostrar
  const obtenerNumerosPagina = useCallback(() => {
    const paginas = [];
    const maxPaginasVisibles = 5;

    if (totalPaginas <= maxPaginasVisibles) {
      for (let i = 1; i <= totalPaginas; i++) {
        paginas.push(i);
      }
    } else {
      if (paginaActual <= 3) {
        for (let i = 1; i <= 4; i++) {
          paginas.push(i);
        }
        paginas.push('...');
        paginas.push(totalPaginas);
      } else if (paginaActual >= totalPaginas - 2) {
        paginas.push(1);
        paginas.push('...');
        for (let i = totalPaginas - 3; i <= totalPaginas; i++) {
          paginas.push(i);
        }
      } else {
        paginas.push(1);
        paginas.push('...');
        for (let i = paginaActual - 1; i <= paginaActual + 1; i++) {
          paginas.push(i);
        }
        paginas.push('...');
        paginas.push(totalPaginas);
      }
    }

    return paginas;
  }, [paginaActual, totalPaginas]);

  const cambiarPagina = useCallback((numeroPagina) => {
    if (numeroPagina >= 1 && numeroPagina <= totalPaginas) {
      setPaginaActual(numeroPagina);
    }
  }, [totalPaginas]);

  // ✅ Callbacks optimizados
  const handleFiltroChange = useCallback((campo, valor) => {
    setFiltros(prev => ({ ...prev, [campo]: valor }));
    setPaginaActual(1); // Reset a página 1 al filtrar
  }, []);


  const handleRegistrosPorPaginaChange = (e) => {
    setRegistrosPorPagina(Number(e.target.value));
    setPaginaActual(1);
  };
  const handleCheckboxChange = (id) => {
    setSelectedCruces(prev =>
      prev.includes(id) ? prev.filter(c => c !== id) : [...prev, id]
    );
  };



  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    let resultados = [];
    cancelRef.current = false;
    setCancelando(false);
    setImportActiva(true);
    setProgreso(0);

    // Conectar al stream de progreso
    const es = await connectToProgressStream();

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      worker: true,
      chunkSize: 1024 * 1024,

      chunk: (results, parser) => {
        parserRef.current = parser; // Guardar el handle para poder abortar el parseo
        resultados = resultados.concat(results.data);
        // Solo mostrar progreso de parsing inicial (no real)
        if (progreso < 5) {
          setProgreso(Math.min(5, (results.meta.cursor / file.size) * 5));
        }
      },

      complete: async () => {
        parserRef.current = null;

        // Si se canceló durante el parseo local, no se envía nada al servidor
        if (cancelRef.current) {
          if (es) es.close();
          setProgreso(null);
          setProgressDetails({ total: 0, processed: 0, inserted: 0, skipped: 0, message: '' });
          setImportActiva(false);
          setCancelando(false);
          document.getElementById('fileInput').value = '';
          alert('🛑 Importación cancelada. No se envió ningún registro al servidor.');
          return;
        }

        try {
          // El backend responde 202 inmediatamente; el progreso llega por SSE.
          await apiClient.post(
            `/api/cruces/importar`,
            resultados,
            { headers: { "x-usuario": "admin" } }
          );
        } catch (error) {
          // Solo mostrar error si la solicitud no llegó al servidor (red, DNS, etc.)
          // Los errores de procesamiento se notifican por SSE con type:'error'
          if (!error.response) {
            console.error("❌ Error al enviar datos al backend:", error);
            alert("❌ No se pudo conectar con el servidor: " + error.message);
            if (es) es.close();
            setProgreso(null);
            setImportActiva(false);
            setCancelando(false);
          }
        } finally {
          document.getElementById('fileInput').value = '';
        }
      },

      error: (err) => {
        console.error("❌ Error al parsear CSV:", err);
        alert(`❌ Error al procesar el archivo CSV: ${err.message || 'Error desconocido'}`);

        if (es) {
          es.close();
        }
        parserRef.current = null;
        setProgreso(null);
        setImportActiva(false);
        setCancelando(false);
        document.getElementById('fileInput').value = '';
      },
    });
  };

  const cancelarImportacion = async () => {
    if (!window.confirm(
      '¿Seguro que deseas cancelar la importación en curso?\n\n' +
      'Los registros que ya fueron insertados se conservarán.'
    )) return;

    setCancelando(true);
    cancelRef.current = true;

    // Fase 1: el CSV todavía se está parseando localmente → abortar el parser.
    // El callback complete de PapaParse hace la limpieza y evita el envío al servidor.
    if (parserRef.current) {
      parserRef.current.abort();
      return;
    }

    // Fase 2: el archivo ya se envió → solicitar la cancelación al backend.
    // El backend responde 409 si la importación aún no inicia (o ya terminó);
    // se reintenta brevemente para cubrir el lapso entre el envío y el inicio del procesamiento.
    for (let intento = 0; intento < 3; intento++) {
      try {
        await apiClient.post(`/api/cruces/importar/cancelar`);
        return; // El backend confirmará con un evento 'cancelled' por SSE
      } catch (error) {
        if (error.response?.status === 409) {
          await new Promise(resolve => setTimeout(resolve, 800));
        } else {
          console.error('Error al cancelar la importación:', error);
          alert('❌ No se pudo cancelar la importación: ' + (error.response?.data?.error || error.message));
          setCancelando(false);
          cancelRef.current = false;
          return;
        }
      }
    }
    // La importación ya no estaba en curso en el servidor (probablemente terminó)
    setCancelando(false);
  };

  const cambiarEstatus = async (idCruce, nuevoEstatus) => {
    try {
      const response = await apiClient.patch(`/api/cruces/${idCruce}/estatus`, { estatus: nuevoEstatus, });

      if (response.status === 200) {
        setCruces(prevCruces =>
          prevCruces.map(cruce =>
            cruce.ID === idCruce ? { ...cruce, Estatus: nuevoEstatus } : cruce
          )
        );
      } else {
        console.error('No se pudo actualizar el estatus');
      }
    } catch (error) {
      console.error('Error al cambiar el estatus:', error);
    }
  };


  const setOTtoanID = async (idCruce, vOT) => {
    try {
      const response = await apiClient.patch(`/api/cruces/${idCruce}/setOT`, {
        vOT: vOT,
      });

      if (response.status === 200) {
        setCruces(prevCruces =>
          prevCruces.map(cruce =>
            cruce.ID === idCruce ? { ...cruce, vOT: vOT } : cruce
          )
        );
      } else {
        console.error('No se pudo actualizar el estatus');
      }
    } catch (error) {
      console.error('Error al cambiar el estatus:', error);
    }
  };
  const triggerClick = () => {
    checkboxes.current.click();
  };



  const CheckStatus = async (Operador, IDCruce, Fecha) => {
    if (!IDCruce) {
      alert(`❌ Error: Cruce inválido. ID recibido: ${IDCruce}`);
      return;
    }

    try {
      const { data } = await apiClient.get(`/api/cruces/statusPersonal/${IDCruce}`);

      if (!data || data.length === 0) {
        alert(`ℹ️ No se encontró información del operador ${Operador} para el cruce ${IDCruce}.`);
        return;
      }
      if (data.status === 500) {
        alert(`🚧🚧 No se encontró información del operador ${Operador} para el cruce ${IDCruce}. 🚧🚧`);
        return;
      }

      let fechaTemp = new Date(Fecha);
      let fechaTemp1 = new Date(Fecha);
      fechaTemp.setDate(fechaTemp.getDate() + 1); // Aumenta un día
      const FechaLimite = fechaTemp.toISOString().split("T")[0]; // Formato YYYY-MM-DD
      fechaTemp1.setDate(fechaTemp1.getDate() - 1); // Aumenta un día
      const FechaLimite1 = fechaTemp1.toISOString().split("T")[0]; // Formato YYYY-MM-DD
      const statusAlterno = (data[0]?.EstatusConcatenado) ? data[0].EstatusConcatenado : data[0].Descripcion;
      const mensajeAdicionalAlterno = (data[0]?.Encabezado === 'Alterno') ?
        `⚠️ No se cuenta con situación personal del OP \nsobre la fecha ${Fecha.split("-")[2].split("T")[0]}/${Fecha.split("-")[1]}/${Fecha.split("-")[0]}\nSe amplió el rango de fechas a un día menos y un día más (${FechaLimite1.split("-")[2].split("T")[0]}/${FechaLimite1.split("-")[1]}/${FechaLimite1.split("-")[0]} - ${FechaLimite.split("-")[2].split("T")[0]}/${FechaLimite.split("-")[1]}/${FechaLimite.split("-")[0]})\n` : '';
      const confirmar = window.confirm(
        `👤 Operador: ${Operador}\n🛣️ Cruce ID: ${IDCruce}\n${mensajeAdicionalAlterno}📋 Status: ${statusAlterno}\n\n¿Deseas confirmar este abuso?`
      );

      if (confirmar) {
        await cambiarEstatus(IDCruce, 'Abuso');
      }

    } catch (error) {
      if (error.response && error.response.status === 404) {
        alert(`🚧🚧  ${JSON.stringify(error.response.data.mensaje).replace("T00:00:00.000Z", "").replaceAll('"', '')}.🚧🚧 `);
        return;
      }
      if (error.response && error.response.status === 400) {
        alert(`ℹ️ No se encontró información del operador ${Operador} para el cruce ${IDCruce}.`);
        return;
      }
      if (error.response && error.response.status === 403) {
        alert(`ℹ️ No tienes permiso para consultar el estado del operador ${Operador} para el cruce ${IDCruce}.`);
        return;
      }
      if (error.response && error.response.status === 401) {
        alert(`ℹ️ No estás autorizado para consultar el estado del operador ${Operador} para el cruce ${IDCruce}.`);
        return;
      }
      if (error.response && error.response.status === 500) {
        alert(`No se encontró información del operador ${Operador} para el cruce ${IDCruce}. 🚧🚧`);
        return;
      }
      console.error("❌ Error al consultar estatus del operador:", error);
      alert(`Error al consultar el estado del operador para el cruce ${IDCruce}.`);
    }
  };




  const actualizarOTMasivo = async (e) => {
    e.preventDefault();
    if (!window.confirm(
      `¿Revalidar la OT y el estatus de ${selectedCruces.length} cruce(s) seleccionado(s)?\n\n` +
      `Esto recalculará la OT asignada usando la lógica corregida (solo OTs iniciadas en los últimos 20 días respecto a la fecha del cruce) ` +
      `y actualizará el estatus, importe oficial e ID de caseta de cada cruce.`
    )) return;

    await connectToProgressStream();

    try {
      await apiClient.patch(`/api/cruces/conciliacionMasiva`, {
        ids: selectedCruces
      });
      setSelectedCruces([]);
    } catch (error) {
      console.error("Error al asignar OT", error);
      alert("❌ Error al reasignar OT: " + (error.response?.data?.error || error.message));
      setProgreso(null);
    }
  };

  const asignarStatusMasivo = async (status) => {
    if (selectedCruces.length === 0) {
      alert("❌ No hay cruces seleccionados para cambiar el estatus.");
      return;
    }
    if (!window.confirm(`¿Estás seguro de que deseas cambiar el estatus de ${selectedCruces.length} cruces a "${status}"?`)) {
      return;
    }
    // Llamar a la función cambiarEstatus para cada ID seleccionado
    try {
      await apiClient.patch(`/api/cruces/masivo-estatus`, {
        ids: selectedCruces.map(id => id),
        nuevoEstatus: status
      });
      // Actualizar la lista de cruces después de cambiar el estatus
      setCruces(prev =>
        prev.map(cruce =>
          selectedCruces.includes(cruce.ID) ? { ...cruce, Estatus: status } : cruce
        )
      );
      setSelectedCruces([]); // Limpiar selección después de la acción masiva
      setRecarga(r => r + 1); // Los conteos y segmentos cambian con el nuevo estatus
    } catch (error) {
      console.error(`Error al cambiar el estatus de los cruces ${selectedCruces}:`, error);
      alert("❌ Error al cambiar el estatus de los cruces seleccionados.");
    }





  };
  const handleSelectAllVisible = () => {
    const visibleIds = idsVisibles; // sólo los de la página actual
    const allSelected = visibleIds.length > 0 && visibleIds.every(ID => selectedCruces.includes(ID));

    if (allSelected) {
      // Quitar todos los visibles
      setSelectedCruces(prev => prev.filter(ID => !visibleIds.includes(ID)));
    } else {
      // Agregar todos los visibles que no estén ya seleccionados
      setSelectedCruces(prev => [
        ...prev,
        ...visibleIds.filter(ID => !prev.includes(ID))
      ]);
    }
  };

  const areAllVisibleSelected = () => {
    return idsVisibles.length > 0 && idsVisibles.every(id => selectedCruces.includes(id));
  };

  const toggleRutaCruce = async (cruce) => {
    if (cruceExpandido === cruce.ID) {
      setCruceExpandido(null);
      return;
    }
    setCruceExpandido(cruce.ID);
    const ot = cruce.id_orden;
    if (!ot || (rutasCache[ot] && !rutasCache[ot].error)) return;

    setRutasCache(prev => ({ ...prev, [ot]: { loading: true } }));
    try {
      const { data: ruta } = await apiClient.get(`/api/cruces/ruta-ot/${encodeURIComponent(ot)}`);
      const casetasRes = ruta.Id_tipo_ruta
        ? await apiClient.get(`/api/casetas/rutas/${ruta.Id_tipo_ruta}/casetasPorRuta`)
        : { data: [] };
      setRutasCache(prev => ({
        ...prev,
        [ot]: { origen: ruta.Origen, destino: ruta.Destino, idTipoRuta: ruta.Id_tipo_ruta, idClave: ruta.ID_clave?.trim() || null, casetas: casetasRes.data || [] }
      }));
    } catch {
      setRutasCache(prev => ({ ...prev, [ot]: { error: true } }));
    }
  };

  const exportarFiltrados = async () => {
    try {
      const { page, pageSize, ...resto } = parametrosConsulta;
      const { data } = await apiClient.get('/api/cruces/consulta', { params: { ...resto, all: 1 } });
      exportarCSV(data.data);
    } catch (error) {
      console.error('Error al exportar cruces:', error);
      alert('❌ Error al exportar la tabla.');
    }
  };

  const SEGMENTOS = [
    { clave: 'accion', etiqueta: 'Requieren acción', clase: 'danger' },
    { clave: 'conOT', etiqueta: 'Con OT', clase: 'success' },
    { clave: 'sinOT', etiqueta: 'Sin OT (Validar asistencia)', clase: 'warning' },
    { clave: 'todos', etiqueta: 'Todos', clase: 'secondary' },
  ];

  return (
    <div className='wrapper' style={{ display: "flex", flexDirection: "column", flex: "1 1 auto" }}>
      {/* Barra de progreso detallada */}
      {(progreso !== null) && (
        <div className="mt-2 mb-3" style={{}}>
          {/* Barra principal */}
          <div className="d-flex align-items-center">
            <div className="progress flex-grow-1" style={{ height: "25px" }}>
              <div
                className={`progress-bar progress-bar-striped progress-bar-animated
                  ${progreso < 30 ? 'bg-info' :
                    progreso < 70 ? 'bg-warning' :
                      progreso === 100 ? 'bg-success' : 'bg-primary'
                  } text-dark font-weight-bold`}
                role="progressbar"
                style={{ width: `${progreso}%` }}
              >
                <span style={{
                  position: 'absolute',
                  textAlign: 'center',
                  lineHeight: '25px',
                  color: progreso > 50 ? '#000' : '#fff',
                  fontWeight: 'bold',
                  justifySelf: 'anchor-center'
                }}>
                  {progreso?.toFixed(1)}% - {progressDetails.message || 'Procesando...'}
                </span>
              </div>
            </div>
            {importActiva && progreso < 100 && (
              <button
                className="btn btn-sm btn-outline-danger ml-2 flex-shrink-0"
                onClick={cancelarImportacion}
                disabled={cancelando}
                title="Detener la importación en curso. Los registros ya insertados se conservan."
              >
                {cancelando ? '⏳ Cancelando…' : '🛑 Cancelar importación'}
              </button>
            )}
          </div>

          {/* Detalles del progreso */}
          {(progressDetails.total > 0) && (
            <div className="mt-2 row text-center" style={{ fontSize: '0.9rem', justifyContent: 'space-around ' }}>
              <div className="col-md-2">
                <span className="badge badge-info">
                  📊 Total: {progressDetails.total?.toLocaleString()}
                </span>
              </div>
              <div className="col-md-2">
                <span className="badge badge-primary">
                  ⚙️ Procesados: {progressDetails.processed?.toLocaleString()}
                </span>
              </div>
              <div className="col-md-2">
                <span className="badge badge-success">
                  ✅ Insertados: {progressDetails.inserted?.toLocaleString()}
                </span>
              </div>
              <div className="col-md-2">
                <span className="badge badge-warning">
                  ⏭️ Omitidos: {progressDetails.skipped?.toLocaleString()}
                </span>
              </div>
              <div className="col-md-2">
                <span className="badge badge-danger">
                  🚫 Restantes: {progressDetails.remaining?.toLocaleString()}
                </span>
              </div>
            </div>
          )}
        </div>
      )}
      <div className="card shadow">
        <div className="card-header py-3 d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <label htmlFor="rowsSelect" className="input-group-text mb-0 mr-2">Registros por página:</label>
            <select
              id="rowsSelect"
              className="form-select form-select-sm custom-select"
              value={registrosPorPagina}
              onChange={(e) => setRegistrosPorPagina(parseInt(e.target.value))}
              style={{ width: 'auto' }}
            >
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={250}>250</option>
            </select>
          </div>

          <h6 className="m-0 font-weight-bold text-primary ml-3" style={{ flex: 'auto', }}>Cruces que aplican según los parametros seleccionados  - (<span className="text sm">{new Intl.NumberFormat("es-MX").format(total)}</span>)

          </h6>
          {selectedCruces.length > 0 && (
            <button
              className="btn-primary text-white px-4 py-1 rounded mr-4"
              onClick={actualizarOTMasivo}
            >
              Reasignar OT a {selectedCruces.length} cruces
            </button>
          )}






          <div className="d-flex gap-2">
            <input
              type="file"
              accept=".csv"
              id="fileInput"
              onChange={handleFileUpload}
              style={{ display: 'none' }}
            />


            <button className="btn btn-success btn-sm pl-2" onClick={() => document.getElementById('fileInput').click()}>
              Cargar cruces
            </button>
            <span className='pl-2'></span>
            <button className="btn btn-outline-primary btn-sm" onClick={exportarFiltrados}>
              Exportar tabla
            </button>
          </div>
        </div>

        <div className="card-body ">


          {/* Este DIV unicamente se muestra cuando se seleccionan cruces */}
          <div className=" justify-content-around float-right border border-secondary rounded p-1 py-0" style={{ display: (selectedCruces.length > 0) ? 'flex' : 'none', }}>
            <div className='col-4 border border-secondary rounded p-1 mr-2 word-wrap'>
              {/* Fila para acomodar las columnas del recuento de los cruces seleccionados */}
              <div className='row px-0' >

                {/* Columna del recuento de los cruces seleccionados (El número de cruces seleccionados) */}
                <div className='col-7 justify-content-end'>
                  <span className="text-info  font-weight-bold" style={{ fontSize: '1.6rem', lineHeight: '1.2rem' }}>{selectedCruces.length}</span>
                </div>


                <div className='col-2 float-right justify-content-end' >
                  <Grid2X2Check size={20} className="me-1  p-0 m-0" />
                </div>


                {/* Columna de las acciones masivas */}
                <div className='col-sm' style={{ fontSize: '.8rem', lineHeight: '0.3rem', textAlign: 'right' }} >
                  {(selectedCruces.length > 1) ? 'Cruces' : 'Cruce'}
                </div>

              </div>
              <div className="row text-center px-0 justify-content-center">

                <span style={{ fontSize: '1rem', lineHeight: '1.5rem' }}>{(selectedCruces.length > 1) ? 'seleccionados' : 'seleccionado'}</span>
              </div>


            </div>
            {/* Columna de las acciones masivas */}
            <div className='col p-1 px-0 '>
              <div className='d-flex align-items-center row text-center' style={{ fontSize: '1.2rem', justifyContent: 'center', lineHeight: '1.4rem' }}>
                <span className="text-muted text-center">Acciones masivas:</span>
              </div>
              <div className='d-flex align-items-center gap-1 row' style={{ justifyContent: 'center', }}>
                <button className="btn btn-md btn-success ml-1 align-top" data-placement="top" title="Marcar TODOS como Confirmados" onClick={() => asignarStatusMasivo('Confirmado')}>
                  ✔
                </button>
                <button className="btn btn-md btn-warning me-1 align-middle ml-1" data-placement="top" title="Marcar TODOS como Aclaración" onClick={() => asignarStatusMasivo('Aclaración')}>
                  ⚠
                </button>
                <button className="btn btn-md btn-danger align-middle ml-1" data-toggle="tooltip" data-placement="top" title="Marcar TODOS como Abuso" onClick={() => asignarStatusMasivo('Abuso')}>
                  🚫
                </button>
                <button className="btn btn-md btn-info me-1 align-middle ml-1" data-toggle="tooltip" data-placement="top" title="Marcar TODOS como Sesgos" onClick={() => asignarStatusMasivo('Error')}>
                  ℹ️
                </button>
              </div>
            </div>
          </div>


          {/* Segmentos de trabajo: qué cruces requieren atención y cuáles ya tienen OT */}
          <ul className="nav nav-pills mb-3">
            {SEGMENTOS.map(s => (
              <li className="nav-item mr-2" key={s.clave}>
                <button
                  type="button"
                  className={`btn btn-sm ${segmento === s.clave ? `btn-${s.clase}` : `btn-outline-${s.clase}`}`}
                  onClick={() => setSegmento(s.clave)}
                >
                  {s.etiqueta} <span className="badge badge-light ml-1">{new Intl.NumberFormat('es-MX').format(conteos[s.clave] || 0)}</span>
                </button>
              </li>
            ))}
          </ul>

          {/* DIV para los filtros */}
          <div className="d-flex flex-wrap gap-2 mb-3">


            {/* DIV para el filtro de fecha */}
            <div className="form-floating pr-2">
              <input type="date" name="fecha"
                className="form-control form-control-sm"
                onChange={handleChange} value={vFecha} id='in_fecha' />
              <label className="form-label" htmlFor='in_fecha'>Fecha Cruce</label>

            </div>




            {/* DIV para el filtro de TAG */}
            <div className="form-floating pr-2" style={{ maxWidth: '9rem', }}>
              <input type="text" name="tagID" className="form-control form-control-sm" placeholder='TAG' onChange={handleChange} value={vtagID} id='in_TagID' />
              <label className="form-label" htmlFor='in_TagID'>TAG</label>

            </div>

            {/* DIV para el filtro de OT */}
            <div className="form-floating pr-2" style={{ maxWidth: '9rem', }}>
              <input type="text" name="vOT" className="form-control form-control-sm" placeholder='OT' onChange={handleChange} value={vOT} id='in_OT' />
              <label className="form-label" htmlFor='in_OT'>OT</label>

            </div>

            {/* DIV para el filtro de Matricula / OP (No_Economico) */}
            <div className="form-floating pr-2" style={{ maxWidth: '11.5rem', }}>
              <input type="text" name="mat_OP" className="form-control form-control-sm" placeholder='Matricula / Operador' onChange={handleChange} value={vmat_OP} id='in_Matricula_Op' />
              <label className="form-label" htmlFor='in_Matricula_Op'>Matricula / Operador</label>

            </div>


            {/* DIV para el filtro de Matricula / OP (No_Economico) */}
            <div className="form-floating pr-2" style={{ maxWidth: '9rem', }}>
              <input type="text" name="Caseta" placeholder="Caseta" className="form-control form-control-sm" onChange={handleChange} value={vCaseta} />
              <label className="form-label">Caseta</label>
            </div>



            <div className='col-md-2  pr-2 input-group-text mb-0 ' style={{ maxWidth: 'min-content', }}>
              <label htmlFor='selectEstatus' className='d-flex align-items-center'>
                <span className='text-muted'>Dictamen:</span>
                <select className='mx-3 p-2' name="Estatus" onChange={handleChange} value={vEstatus} id='selectEstatus' style={{ width: 'auto', height: '2.5rem' }}>
                  <option value="">Todos</option>
                  <option value="Abuso">🚫 Abusos</option>
                  <option value="Aclaración">⚠️ Aclaraciones</option>
                  <option value="Confirmado">✔️ Confirmados</option>
                  <option value="Error">ℹ️ Error</option>
                  <option value="CasetaNoEncontradaEnRuta">🚧 Cruce sin relación</option>
                  <option value="Se cobró menos">⭐ Cobro menor</option>
                  <option value="Pendiente">⏳ Pendientes</option>
                </select>
              </label>
            </div>


            <div className="ml-3 pr-1 pt-1 d-flex">
              <button className="btn btn-sm btn btn-outline-dark rounded-3" onClick={resetFiltros}>
                <FunnelX size={25} className="me-1" />
              </button>
            </div>

          </div>

          {/* DIV para la tabla */}
          <div className="table-responsive table-container " style={{ maxHeight: '50rem' }}>



            <div className="mb-4 d-flex flex-column">
              <h5 className="mb-2">Filtrar por Mes:</h5>
              <div className="d-flex flex-wrap gap-2 mb-3">
                {meses.map((mes, i) => (
                  <button
                    key={i}
                    className={`btn btn-sm ${mesSeleccionado === i ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => {
                      setMesSeleccionado(i);
                      setSearchParams(prev => {
                        const newParams = new URLSearchParams(prev);
                        newParams.set('m', i + 1);
                        return newParams;
                      });
                    }}
                  >
                    {mes}
                  </button>
                ))}
                <button
                  className={`btn btn-sm ${mesSeleccionado === null ? "btn-secondary" : "btn-outline-secondary"}`}
                  onClick={() => {
                    setMesSeleccionado(null);
                    setSearchParams(prev => {
                      const newParams = new URLSearchParams(prev);
                      newParams.delete('m');
                      return newParams;
                    });
                  }}
                >
                  Todos
                </button>
              </div>
              <h5 className="mb-2">Filtrar por Año:</h5>
              <div className="d-flex flex-wrap gap-2 mb-3">
                {years.map((year, i) => (
                  <button
                    key={i}
                    className={`btn btn-sm ${selectedYear?.AÑO === year.AÑO ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => {
                      const newYear = selectedYear?.AÑO === year.AÑO ? null : year;
                      setSelectedYear(newYear);
                      setSearchParams(prev => {
                        const newParams = new URLSearchParams(prev);
                        if (newYear) newParams.set('y', newYear['AÑO']);
                        else newParams.delete('y');
                        return newParams;
                      });
                    }}
                  >
                    {year['AÑO']}
                  </button>
                ))}
                <button
                  className={`btn btn-sm ${selectedYear === null ? "btn-secondary" : "btn-outline-secondary"}`}
                  onClick={() => {
                    setSelectedYear(null);
                    setSearchParams(prev => {
                      const newParams = new URLSearchParams(prev);
                      newParams.delete('y');
                      return newParams;
                    });
                  }}
                >
                  Todos
                </button>
              </div>

              <h5 className="mb-2">Filtrar por:</h5>
              <div className="d-flex flex-wrap gap-2">
                {bases.map((base, i) => (
                  <button
                    key={i}
                    className={`btn btn-sm ${baseSeleccionada === base ? "btn-success" : "btn-outline-success"}`}
                    onClick={() => setBaseSeleccionada(baseSeleccionada === base ? null : base)}
                  >
                    {base}
                  </button>
                ))}
                <button
                  className={`btn btn-sm ${baseSeleccionada === null ? "btn-secondary" : "btn-outline-secondary"}`}
                  onClick={() => setBaseSeleccionada(null)}
                >
                  Todo
                </button>
              </div>
            </div>


            <table className="table table-bordered table-scroll table-sm table-hover align-middle" width="100%" cellSpacing="0">
              <thead>
                <tr>
                  <th onClick={triggerClick} >
                    <input tabIndex={1}
                      type="checkbox" ref={checkboxes}
                      style={{ height: '15px', width: '15px', }}
                      onChange={handleSelectAllVisible}
                      checked={areAllVisibleSelected()}
                      id='SelectAll'
                    />
                  </th>
                  <th className='px-0' style={{ textAlign: 'center' }}>IDx </th>
                  <th onClick={() => ordenarPor('Tag')} style={{ cursor: 'pointer' }}>Tag {sortColumn === 'Tag' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                  <th onClick={() => ordenarPor('No_Economico')} style={{ cursor: 'pointer' }}>No. Económico {sortColumn === 'No_Economico' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                  <th onClick={() => ordenarPor('Fecha')} style={{ cursor: 'pointer' }}>Fecha {sortColumn === 'Fecha' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                  <th onClick={() => ordenarPor('Caseta')} style={{ cursor: 'pointer' }}>Caseta {sortColumn === 'Caseta' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                  <th onClick={() => ordenarPor('Carril')} style={{ cursor: 'pointer' }}>Carril {sortColumn === 'Carril' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                  <th onClick={() => ordenarPor('Clase')} style={{ cursor: 'pointer' }}>Clase {sortColumn === 'Clase' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                  <th onClick={() => ordenarPor('Importe')} style={{ cursor: 'pointer' }}>Importe {sortColumn === 'Importe' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                  <th onClick={() => ordenarPor('ImporteOficial')} style={{ cursor: 'pointer' }}>Tarifa TUSA {sortColumn === 'ImporteOficial' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                  <th onClick={() => ordenarPor('id_orden')} style={{ cursor: 'pointer' }}> OT {sortColumn === 'id_orden' && (sortDirection === 'asc' ? '↑' : '↓')}</th>


                  <th onClick={() => ordenarPor('FechaAplicacion')} style={{ cursor: 'pointer' }}> Aplicado el  {sortColumn === 'FechaAplicacion' && (sortDirection === 'asc' ? '↑' : '↓')}</th>



                  <th onClick={() => ordenarPor('Estatus')} style={{ cursor: 'pointer', lineHeight: '.8rem', fontSize: '.9rem' }}>Dictamen <br />del cruce {sortColumn === 'Estatus' && (sortDirection === 'asc' ? '↑' : '↓')}</th>
                  <th >Acciones </th>

                </tr>
              </thead>
              <tbody>
                {(loading ? [] : paginaDatos).map((cruce, i) => (
                  <Fragment key={cruce.ID}>
                  <tr className={'py-0 align-middle ' + ((cruce.Estatus === 'Confirmado') ? 'font-weight-bolder text-success' : (cruce.Estatus === 'Abuso') ? 'font-weight-bolder text-danger' : (cruce.Estatus === 'Aclaración') ? 'font-weight-bolder text-warning' : (cruce.Estatus === 'Error') ? 'font-weight-bolder text-info' : 'font-weight-bolder text-dark')}>
                    <td className='py-1 align-middle '> <input
                      type="checkbox" tabIndex={i + 2}
                      checked={selectedCruces.includes(cruce.ID)}
                      onChange={() => handleCheckboxChange(cruce.ID)}
                    />
                    </td>
                    <td className='py-1 align-middle '>{(paginaActual-1) * registrosPorPagina + i + 1}</td>
                    <td className='py-1 align-middle '>{cruce.Tag}</td>
                    <td className='py-1 align-middle '>{cruce["No_Economico"]}</td>

                    <td className='py-1 align-middle '>{formatearFechaHora(cruce.Fecha)}</td>

                    <td className='p-0 py-1 align-middle text-center '>{cruce.Caseta}</td>
                    <td className='p-0 py-1 align-middle text-center '>{cruce.Carril}</td>
                    <td className='p-0 py-1 text-center align-middle '>{cruce.Clase}</td>
                    <td className='p-0 py-1 text-center align-middle '>

                      <span className='fw-bold' title={(cruce.Estatus === 'Se cobró menos') ? `Se cobraron $${parseFloat(cruce.ImporteOficial - cruce.Importe).toFixed(2)} menos ` : ''}>${parseFloat(cruce.Importe).toFixed(2)} {(cruce.Estatus === 'Se cobró menos') && '⭐'}</span>

                    </td>
                    <td className='p-0 py-1 text-center align-middle '>
                      <span className={`text-info fw-bold text-center`} >${parseFloat(cruce.ImporteOficial).toFixed(2)}</span> <span className='float-end' title='Tarifa confirmada.'> {(cruce.ImporteOficial === cruce.Importe ? '⭐' : '')}</span>
                    </td>



                    <td className='p-0 py-1 text-center align-middle'><span onClick={() => CheckStatus(cruce["No_Economico"], cruce.ID, cruce.Fecha)} style={{
                      cursor: 'pointer',
                      color: (!cruce.id_orden) ? 'red' : '',
                      textDecoration: (!cruce.id_orden) ? 'underline' : 'none',
                      backgroundColor: (!cruce.id_orden) ? '#f8d7da' : '#d4edda',
                      padding: '0.2rem 0.5rem',
                      fontSize: (!cruce.id_orden) ? '0.7rem' : '',
                    }}>{(cruce.id_orden) || "Validar asistencia"}</span></td>





                    <td className='p-0 py-1 align-middle text-center '>{formatearFecha(cruce.FechaAplicacion)}</td>
                    <td className='p-0 py-1 align-middle text-center '>{cruce.Estatus || "Pendiente"}</td>
                    <td className='p-0 text-center py-1' style={{textAlignLast:'start'}}>
                      <button className="btn btn-sm btn-success ml-1 align-top" data-placement="top" title="Cruce OK" onClick={() => cambiarEstatus(cruce.ID, 'Confirmado')}>
                        ✔
                      </button>
                      <button className="btn btn-sm btn-warning me-1 align-middle ml-1" data-placement="top" title="Se solicitará aclaración" onClick={() => cambiarEstatus(cruce.ID, 'Aclaración')}>
                        ⚠
                      </button>
                      <button className="btn btn-sm btn-danger align-middle ml-1" data-toggle="tooltip" data-placement="top" title="Marcar como abuso" onClick={() => cambiarEstatus(cruce.ID, 'Abuso')}>
                        🚫
                      </button>
                      <button className="btn btn-sm btn-info me-1 align-middle ml-1" data-toggle="tooltip" data-placement="top" title="Diferencia por registros" onClick={() => cambiarEstatus(cruce.ID, 'Error')}>
                        ℹ️
                      </button>
                      {cruce.Estatus === 'CasetaNoEncontradaEnRuta' && cruce.id_orden && (
                        <button
                          className={`btn btn-sm align-middle ml-1 ${cruceExpandido === cruce.ID ? 'btn-secondary' : 'btn-outline-secondary'}`}
                          title="Ver la ruta de la OT y el vínculo del cruce"
                          onClick={() => toggleRutaCruce(cruce)}
                        >
                          <i className={`fas fa-chevron-${cruceExpandido === cruce.ID ? 'up' : 'down'}`}></i>
                        </button>
                      )}
                      {cruce.Estatus === 'CasetaNoEncontradaEnRuta' && (
                        <button
                          className="btn btn-sm btn-outline-warning align-middle ml-1"
                          title="Editar casetas de la ruta"
                          onClick={() => handleOpenEditRutaForCruce(cruce)}
                          disabled={editRutaPanelLoading}
                        >
                          {editRutaPanelLoading ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-edit"></i>}
                        </button>
                      )}
                    </td>
                  </tr>
                  {cruceExpandido === cruce.ID && (
                    <tr>
                      <td colSpan="14" className="bg-light text-dark" style={{ fontWeight: 'normal' }}>
                        <RutaCruce cruce={cruce} ruta={rutasCache[cruce.id_orden]} onVinculado={() => setRecarga(r => r + 1)} />
                      </td>
                    </tr>
                  )}
                  </Fragment>
                ))}
                {loading && (
                  <tr><td colSpan="14" className="text-center py-3">
                    <div className="spinner-border spinner-border-sm text-primary mr-2" role="status"></div>
                    Cargando cruces...
                  </td></tr>
                )}
                {!loading && paginaDatos.length === 0 && (
                  <tr><td colSpan="14" className="text-center">
                    No existen registros.
                  </td></tr>
                )}
              </tbody>
            </table>

          </div>
          {/* Paginación */}
          <div className='assignMe'>
            <nav className="mt-3">
              <div className="d-flex justify-content-between align-items-center mb-2 px-2">
                <span className="text-muted small">
                  Mostrando {paginaDatos.length > 0 ? indiceInicio + 1 : 0} - {indiceInicio + paginaDatos.length} de {total} registros
                </span>
                <span className="text-muted small">
                  Página {totalPaginas > 0 ? paginaActual : 0} de {totalPaginas}
                </span>
              </div>

              <ul className="pagination pagination-sm justify-content-center d-flex flex-wrap" style={{ overflow: 'auto', }}>
                <li className={`flex-wrap page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
                  <button
                    className="page-link"
                    onClick={() => cambiarPagina(paginaActual - 1)}
                    disabled={paginaActual === 1}
                  >
                    Anterior
                  </button>
                </li>

                {obtenerNumerosPagina().map((numero, index) => (
                  numero === '...' ? (
                    <li key={`ellipsis-${index}`} className="flex-wrap page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  ) : (
                    <li key={`page-${numero}`} className={`flex-wrap page-item ${paginaActual === numero ? 'active' : ''}`}>
                      <button
                        className="page-link"
                        onClick={() => cambiarPagina(numero)}
                      >
                        {numero}
                      </button>
                    </li>
                  )
                ))}

                <li className={`flex-wrap page-item ${paginaActual === totalPaginas || totalPaginas === 0 ? 'disabled' : ''}`}>
                  <button
                    className="page-link"
                    onClick={() => cambiarPagina(paginaActual + 1)}
                    disabled={paginaActual === totalPaginas || totalPaginas === 0}
                  >
                    Siguiente
                  </button>
                </li>
              </ul>
            </nav>
          </div>



        </div>
      </div>
      {editRutaPanelData && (
        <EditRutaPanel
          id_tipo_ruta={editRutaPanelData.id_tipo_ruta}
          ot={editRutaPanelData.ot}
          initialCasetas={editRutaPanelData.initialCasetas}
          onClose={() => setEditRutaPanelData(null)}
          onSaved={() => setEditRutaPanelData(null)}
        />
      )}
      {showModal && cruceSeleccionado && <ModalHandleEditarCruce isOpen={showModal} onClose={() => setShowModal(false)} cruceSeleccionado={cruceSeleccionado} onConfirm={(DatosAGuardar)=>{
        apiClient.patch(`/api/cruces/${cruceSeleccionado.ID}/editar`, DatosAGuardar).then(response=>{
          if(response.status === 200){
            setCruces(prevCruces => prevCruces.map(cruce => cruce.ID === cruceSeleccionado.ID ? {...cruce, ...DatosAGuardar} : cruce));
            alert("Cruce actualizado correctamente");
          } else {
            alert("Error al actualizar el cruce");
          }
        }).catch(error=>{
          console.error("Error al actualizar el cruce:", error);
          alert("Error al actualizar el cruce");
        });
      }}/>}
    </div >
  );
}

// Clave de la unidad (Orden_traslados.ID_clave) → columna de tarifa en casetas_Plantillas
const claveToImporteField = {
  'A': 'Automovil',
  'B': 'Autobus2Ejes',
  'C-2': 'Camion2Ejes',
  'C-3': 'Camion3Ejes',
  'C-4': 'Camion3Ejes',
  'C-5': 'Camion5Ejes',
  'C-9': 'Camion9Ejes'
};

// Detalle de la ruta de la OT del cruce, resaltando la caseta con la que se vinculó el cruce.
// Si el cruce está en CasetaNoEncontradaEnRuta, permite vincular el nombre PASE a una caseta de la ruta
// (Cat_EntidadCaseta) y re-dictaminar todos los cruces con ese nombre.
function RutaCruce({ cruce, ruta, onVinculado }) {
  const [casetaElegida, setCasetaElegida] = useState(null); // ID_Caseta elegido a mano (si no, la que coincide por nombre)
  const [preview, setPreview] = useState(null); // { loading } | { error } | respuesta de /vinculo-caseta/preview
  const [guardando, setGuardando] = useState(false);

  if (!ruta || ruta.loading) {
    return <div className="py-2"><span className="spinner-border spinner-border-sm text-primary mr-2"></span>Cargando ruta...</div>;
  }
  if (ruta.error) return <div className="py-2 text-danger">No se pudo cargar la ruta de la OT.</div>;

  const nombreCruce = (cruce.Caseta || '').trim().toLowerCase();
  const esVinculada = (c) => {
    if (cruce.idCaseta != null && c.ID_Caseta != null && String(c.ID_Caseta) === String(cruce.idCaseta)) return true;
    const nombres = [c.Nombre_IAVE, c.Nombre, c.Caseta].filter(Boolean).map(n => String(n).trim().toLowerCase());
    return nombreCruce !== '' && nombres.includes(nombreCruce);
  };
  const hayVinculo = ruta.casetas.some(esVinculada);
  const columnaTarifa = claveToImporteField[ruta.idClave];
  const importeCaseta = (c) => (columnaTarifa && c[columnaTarifa] != null ? parseFloat(c[columnaTarifa]) : null);
  const totalRuta = ruta.casetas.reduce((acc, c) => acc + (importeCaseta(c) || 0), 0);

  const puedeVincular = cruce.Estatus === 'CasetaNoEncontradaEnRuta' && Boolean(cruce.Caseta);
  const idCandidata = casetaElegida ?? ruta.casetas.find(esVinculada)?.ID_Caseta ?? null;
  const candidata = ruta.casetas.find(c => c.ID_Caseta === idCandidata);
  const nombreCaseta = (c) => c.Nombre_IAVE || c.Nombre || c.Caseta || c.ID_Caseta;

  const elegirCaseta = (c) => {
    if (!puedeVincular || guardando) return;
    setCasetaElegida(c.ID_Caseta);
    setPreview(null);
  };

  const verImpacto = async () => {
    setPreview({ loading: true });
    try {
      const { data } = await apiClient.get('/api/cruces/vinculo-caseta/preview', {
        params: { nombre: cruce.Caseta, idCaseta: idCandidata }
      });
      setPreview(data);
    } catch {
      setPreview({ error: true });
    }
  };

  const confirmarVinculo = async () => {
    setGuardando(true);
    try {
      const { data } = await apiClient.post('/api/cruces/vinculo-caseta', { nombre: cruce.Caseta, idCaseta: idCandidata });
      alert(data.message);
      setPreview(null);
      if (onVinculado) onVinculado();
    } catch {
      alert('Error al guardar el vínculo de la caseta');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="py-2">
      <div className="mb-2">
        <strong>OT {cruce.id_orden}</strong>: {ruta.origen || 'Origen N/D'} <i className="fas fa-arrow-right mx-1"></i> {ruta.destino || 'Destino N/D'}
        <span className="text-muted ml-2">({ruta.casetas.length} casetas en la ruta)</span>
        {columnaTarifa
          ? <span className="ml-3">Clase unidad <strong>{ruta.idClave}</strong> ({columnaTarifa}) · Total ruta: <strong className="text-info">${totalRuta.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></span>
          : <span className="ml-3 text-warning">Clase de la unidad no identificada{ruta.idClave ? ` (${ruta.idClave})` : ''}; no se pueden calcular importes.</span>}
      </div>
      <div className="d-flex flex-wrap align-items-center">
        {ruta.casetas.map((c, idx) => {
          const vinculada = esVinculada(c);
          const importe = importeCaseta(c);
          const elegida = puedeVincular && c.ID_Caseta === idCandidata;
          return (
            <Fragment key={c.ID_Caseta ?? idx}>
              {idx > 0 && <span className="mx-1 text-muted">→</span>}
              <span
                className={`badge ${vinculada ? 'badge-success' : 'badge-light border'} p-2`}
                style={{
                  cursor: puedeVincular ? 'pointer' : 'default',
                  outline: elegida ? '2px solid #17a2b8' : 'none',
                  outlineOffset: '2px'
                }}
                title={puedeVincular ? `Elegir para vincular "${cruce.Caseta}"` : (vinculada ? 'Caseta vinculada al cruce' : '')}
                onClick={() => elegirCaseta(c)}
              >
                {nombreCaseta(c)}
                {importe != null && <span className="d-block mt-1 font-weight-normal">${importe.toFixed(2)}</span>}
              </span>
            </Fragment>
          );
        })}
        {ruta.casetas.length === 0 && <span className="text-muted">La ruta no tiene casetas registradas.</span>}
      </div>
      {!hayVinculo && !candidata && (
        <div className="mt-2 text-danger">
          La caseta del cruce (<strong>{cruce.Caseta}</strong>) no está en la ruta. Usa "Editar casetas de la ruta" para agregarla
          {puedeVincular && ruta.casetas.length > 0 && <> o, si aparece con otro nombre, da clic en la caseta correspondiente para vincularla</>}.
        </div>
      )}
      {puedeVincular && candidata && (
        <div className="mt-3 p-2 border rounded bg-white">
          <div className="d-flex flex-wrap align-items-center">
            <span className="mr-2">
              Vincular el nombre PASE <strong>"{cruce.Caseta}"</strong> con la caseta <strong>{nombreCaseta(candidata)}</strong> (ID {candidata.ID_Caseta})
              {importeCaseta(candidata) != null && <> · tarifa {ruta.idClave} <strong>${importeCaseta(candidata).toFixed(2)}</strong></>}
            </span>
            {!preview && (
              <button className="btn btn-sm btn-outline-info" onClick={verImpacto}>Ver impacto</button>
            )}
          </div>
          {preview?.loading && <div className="mt-2"><span className="spinner-border spinner-border-sm text-info mr-2"></span>Calculando cruces afectados...</div>}
          {preview?.error && <div className="mt-2 text-danger">No se pudo calcular el impacto del vínculo.</div>}
          {preview && !preview.loading && !preview.error && (
            <div className="mt-2">
              <div>
                {preview.aliasExiste
                  ? <>El vínculo ya existe en el catálogo de casetas.</>
                  : <>Se registrará <strong>"{cruce.Caseta}"</strong> como nombre alterno de la caseta (Cat_EntidadCaseta); las próximas cargas lo reconocerán solas.</>}
              </div>
              {preview.aliasOtrasCasetas.length > 0 && (
                <div className="text-warning">
                  Ojo: ese nombre también está vinculado a {preview.aliasOtrasCasetas.map(a => `${a.Nombre_IAVE || a.Nombre || 'caseta'} (ID ${a.Id_caseta})`).join(', ')}.
                </div>
              )}
              <div className="mt-1">
                Se re-dictaminarán <strong>{preview.totalActualizables}</strong> cruce(s) en "Cruce sin relación" cuya OT tiene esta caseta en su ruta:
                <ul className="mb-1">
                  {preview.porEstatus.map(e => (
                    <li key={e.Estatus}>
                      {e.Estatus}: <strong>{e.Cruces}</strong> · cobrado ${Number(e.Importe).toFixed(2)} vs tarifa ${Number(e.Tarifa).toFixed(2)}
                    </li>
                  ))}
                </ul>
                {preview.conTarifaHistorica > 0 && <div className="text-muted">{preview.conTarifaHistorica} cruce(s) se evaluaron con la tarifa vigente a su fecha (histórico de casetas), distinta de la actual.</div>}
                {preview.fueraDeRuta > 0 && <div className="text-muted">{preview.fueraDeRuta} cruce(s) con el mismo nombre quedan pendientes porque la caseta no está en la ruta de su OT.</div>}
                {preview.sinTarifa > 0 && <div className="text-muted">{preview.sinTarifa} cruce(s) quedan pendientes porque la caseta no tiene tarifa para la clase de su unidad.</div>}
              </div>
              <button className="btn btn-sm btn-info mr-2" onClick={confirmarVinculo} disabled={guardando || preview.totalActualizables === 0}>
                {guardando ? 'Guardando...' : 'Confirmar vinculación'}
              </button>
              <button className="btn btn-sm btn-outline-secondary" onClick={() => setPreview(null)} disabled={guardando}>Cancelar</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function exportarCSV(data) {
  const headers = ['Tag', 'No_Economico', 'Fecha', 'Caseta', 'Importe', 'Carril', 'Clase', 'ImporteOficial', 'OT', 'FechaAplicacion', 'Estatus'];
  const rows = data.map(item => [
    item.Tag,
    item["No_Economico"],
    new Date(item.Fecha).toLocaleDateString(),
    item.Caseta,
    item.Importe,
    item.Carril,
    item.Clase,
    item.ImporteOficial,
    item.id_orden || '',
    new Date(item.FechaAplicacion).toLocaleDateString(),
    item.Estatus,
  ]);

  const csv = [headers, ...rows].map(row => row.join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `reporte IAVE, cruces ${Date.now()}.csv`;
  link.click();
}

export default CrucesTable;




